import { InjectionToken } from "@angular/core";
export const MESSAGE_FORMAT_CONFIG = new InjectionToken("MESSAGE_FORMAT_CONFIG");
export const defaultConfig = {
    biDiSupport: false,
    formatters: undefined,
    locales: undefined,
    strictNumberSign: false,
    disablePluralKeyChecks: false,
};
